/* eslint-disable no-else-return */
export const removeUrlPrefix = url => {
  if (url.substring(0, 7) === 'http://') {
    url = url.substring(7, url.length)
    return url
  } else if (url.substring(0, 8) === 'https://') {
    url = url.substring(8, url.length)
    return url
  }
  return url
}

export const urlPrefix = url => {
  if (url.substring(0, 7) !== 'http://' || url.substring(0, 8) !== 'https://') {
    url = `https://${url}`
    return url
  }
  return url
}

export function replaceMultipleSlashes(url) {
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  return url.replace(/(https?:\/\/)(.*)/, (match, protocol, rest) => protocol + rest.replace(/\/+/g, '/'))
}
